import React, { Component } from 'react'
import './receive.css'

class WhatReceiveComponent extends Component {
  render() {
    return (
      <>
        <h1 style={{ marginTop: '6rem' }}>
          Esto es exactamente lo que obtienes al entrar hoy
        </h1>
        <div className="receive-container">
          <div className="receive-card">
            <i class="far fa-check-circle"></i>
            <div className="contend">
              <h4>Plan nutricional diseñado para ti</h4>
              <p>
                No vas a hacer dieta. Comes lo que TU cuerpo realmente necesita.
              </p>
            </div>
          </div>

          <div className="receive-card">
            <i class="far fa-check-circle"></i>

            <div className="contend">
              <h4>Ajuste real de calorías y macros</h4>
              <p>Cada gramo tiene un propósito. Nada es relleno.</p>
            </div>
          </div>

          <div className="receive-card">
            <i class="far fa-check-circle"></i>

            <div className="contend">
              <h4>Estructura flexible o fija (tú eliges)</h4>
              <p>
                Si quieres libertad, la tienes, si quieres precisión, también
              </p>
            </div>
          </div>

          <div className="receive-card">
            <i class="far fa-check-circle"></i>

            <div className="contend">
              <h4>Guía práctica para entender tu cuerpo</h4>
              <p>
                Dejas de depender de dietas o nutricionistas. Empiezas a decidir
                con criterio propio.
              </p>
            </div>
          </div>

          <div className="receive-card">
            <i class="far fa-check-circle"></i>

            <div className="contend">
              <h4>Lista de compras automática</h4>
              <p>Vas al súper sin pensar.</p>
            </div>
          </div>

          <div className="receive-card">
            <i class="far fa-check-circle"></i>

            <div className="contend">
              <h4>Soporte humano real</h4>
              <p>No un bot. Personas reales detrás.</p>
            </div>
          </div>
        </div>
        <div className="diferent-container">
          <h3>¿Por qué esto funciona cuando todo lo demás falla?</h3>
          <p>
            Porque no usamos plantillas. Usamos un sistema de ajuste
            bioindividual que:
          </p>
          <ul>
            <li>Se adapta a tu cuerpo</li>
            <li>Respeta tus horarios</li>
            <li>Se ajusta a tu metabolismo</li>
            <li>Evoluciona contigo</li>
          </ul>
          <p>
            No seguimos modas, seguimos BIOLOGÍA y ahí empieza el resultado real
          </p>
        </div>
        <div className="isthisfor-container">
          <div className="card yes">
            <div className="header">
              <i class="far fa-check-circle"></i>
              <h4>Este sistema es para ti si</h4>
            </div>
            <ul>
              <li>● Estás cansado de empezar y abandonar dietas.</li>
              <li>● Comes “sano” y no mejoras.</li>
              <li>● Te inflamas con todo.</li>
              <li>● Odias pesar comida.</li>
              <li>● No quieres vivir esclavo del fitness.</li>
              <li>● Quieres estructura SIN obsesión.</li>
            </ul>
          </div>
          <div className="card not">
            <div className="header">
              <i class="far fa-times-circle"></i>
              <h4>No es para ti si</h4>
            </div>
            <ul>
              <li>● No piensas seguir nada.</li>
              <li>● Buscas magia.</li>
              <li>● Quieres resultados sin cambiar nada.</li>
              <li>● Te gusta quejarte más que actuar.</li>
            </ul>
          </div>
        </div>
      </>
    )
  }
}
export default WhatReceiveComponent
